import { useCallback } from "react";

import { useMutationWithState } from "hooks";

export function useSaveCommentDraft(clientId, commentGid) {
  const mutationFactory = useCallback(() => {
    const query = `mutation saveDraft($clientId: ID!, $commentGid: ID, $content: String!, $draftGid: ID, $taskUuid: UUID,
              $clientWorkflowUuid: UUID, $force: Boolean){
          saveDraft(clientId: $clientId, commentGid: $commentGid, content: $content, draftGid: $draftGid, taskUuid: $taskUuid, 
                  clientWorkflowUuid: $clientWorkflowUuid, force: $force) {
              successMessage
              draftGid
              updatedAt
          }                    
        }
    `;

    const resolver = ({ data, errors }) => {
      return {
        data: data.saveDraft,
        errors: errors,
      };
    };

    return { query, resolver };
  }, []);

  const [mutation, { data, errors, loading }] =
    useMutationWithState(mutationFactory);

  return {
    updatedAt: data ? data.updatedAt : null,
    savingErrors: errors,
    isSavingDraft: loading,
    saveDraft: async (
      content,
      draftGid,
      taskUuid,
      clientWorkflowUuid,
      force = false
    ) => {
      if (!content) {
        return {};
      }
      return mutation({
        clientId: clientId,
        commentGid: commentGid,
        content: content,
        draftGid: draftGid,
        taskUuid: taskUuid,
        clientWorkflowUuid: clientWorkflowUuid,
        force: force,
      });
    },
  };
}

export default useSaveCommentDraft;
